module.exports = __webpack_public_path__ + "img/wechat3.b7495e99.jpg";